(() => {
  const DRAG_START_THRESHOLD = 12;
  const CLICK_SUPPRESS_MS = 260;
  const TARGET_SELECTOR = 'slider-component.top-picks__slider, slider-component.shop-by-media__slider';

  const isSupportedPointer = (event) => ['mouse', 'touch', 'pen'].includes(event.pointerType);

  const bindDrag = (component) => {
    if (!(component instanceof HTMLElement)) return;
    if (component.dataset.dragSliderBound === 'true') return;

    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let isPointerDown = false;
    let isDragging = false;
    let suppressClickUntil = 0;

    const clearState = (event) => {
      if (!isPointerDown) return;

      const wasDragging = isDragging;

      if (pointerId !== null && slider.hasPointerCapture(pointerId)) {
        slider.releasePointerCapture(pointerId);
      }

      pointerId = null;
      isPointerDown = false;

      if (isDragging) {
        isDragging = false;
        component.classList.remove('is-dragging');
        if (typeof component.update === 'function') component.update();
      }

      if (wasDragging) {
        suppressClickUntil = Date.now() + CLICK_SUPPRESS_MS;
      }
    };

    slider.addEventListener('pointerdown', (event) => {
      if (!isSupportedPointer(event)) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      isPointerDown = true;
      isDragging = false;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = slider.scrollLeft;
      pointerId = event.pointerId;
    });

    slider.addEventListener('pointermove', (event) => {
      if (!isPointerDown) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (!isDragging) {
        if (Math.abs(deltaX) < DRAG_START_THRESHOLD) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          clearState(event);
          return;
        }
        isDragging = true;
        component.classList.add('is-dragging');

        if (typeof slider.setPointerCapture === 'function') {
          slider.setPointerCapture(pointerId);
        }
      }

      event.preventDefault();
      slider.scrollLeft = startScrollLeft - deltaX;
    });

    slider.addEventListener('pointerup', clearState);
    slider.addEventListener('pointercancel', clearState);
    slider.addEventListener('lostpointercapture', clearState);

    slider.addEventListener(
      'click',
      (event) => {
        if (Date.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClickUntil = 0;
      },
      true
    );

    slider.addEventListener('dragstart', (event) => event.preventDefault());

    component.dataset.dragSliderBound = 'true';
  };

  const init = (scope = document) => {
    scope.querySelectorAll(TARGET_SELECTOR).forEach(bindDrag);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
